export default __webpack_public_path__ + "static/media/gy.e930e3b9.svg";